import { render } from "./CommonAlertModal.vue?vue&type=template&id=66c95970"
import script from "./CommonAlertModal.vue?vue&type=script&lang=js"
export * from "./CommonAlertModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\geneuin\\developer\\hwian\\hwian-install-mobile-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__